// import { useState, useEffect, useMemo } from 'react';
// import dayjs from 'dayjs';

// // Export functionality
// export const handleExportToCSV = (notifications) => {
//   const exportData = notifications.map((notification) => ({
//     'Plant Name': notification.plantName,
//     Type: notification.type,
//     Message: notification.message,
//     Status: notification.status,
//     Severity: notification.severity,
//     'Created Date': dayjs(notification.created_at).format('DD-MM-YYYY HH:mm:ss'),
//     'Last Data Time': dayjs(notification.lastDataTime).format('DD-MM-YYYY HH:mm:ss'),
//     Resolved: notification.resolved ? 'Yes' : 'No',
//     'Resolution Time': notification.resolutionTime
//       ? dayjs(notification.resolutionTime).format('DD-MM-YYYY HH:mm:ss')
//       : 'N/A',
//     'Email Sent': notification.emailSent ? 'Yes' : 'No',
//     'Escalation Level': notification.escalationLevel,
//     Processed: notification.processed ? 'Yes' : 'No',
//   }));

//   // Create CSV content
//   const headers = Object.keys(exportData[0]).join(',');
//   const csvContent = exportData
//     .map((row) => Object.values(row).join(','))
//     .join('\n');
//   const csv = headers + '\n' + csvContent;

//   // Download CSV file
//   const blob = new Blob([csv], { type: 'text/csv' });
//   const url = window.URL.createObjectURL(blob);
//   const a = document.createElement('a');
//   a.href = url;
//   a.download = `notifications_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   window.URL.revokeObjectURL(url);
// };

// // Filter notifications based on search criteria
// export const filterNotifications = ({
//   notifications,
//   searchName,
//   selectedStatus,
//   selectedSeverity,
//   selectedType,
//   fromDate,
//   toDate,
// }) => {
//   let filtered = [...notifications];

//   // Search by plant name, type, or message
//   if (searchName) {
//     filtered = filtered.filter(
//       (notification) =>
//         notification.plantName.toLowerCase().includes(searchName.toLowerCase()) ||
//         notification.type.toLowerCase().includes(searchName.toLowerCase()) ||
//         notification.message.toLowerCase().includes(searchName.toLowerCase())
//     );
//   }

//   // Filter by status
//   if (selectedStatus) {
//     filtered = filtered.filter(
//       (notification) => notification.status === selectedStatus
//     );
//   }

//   // Filter by severity
//   if (selectedSeverity) {
//     filtered = filtered.filter(
//       (notification) => notification.severity === selectedSeverity
//     );
//   }

//   // Filter by type
//   if (selectedType) {
//     filtered = filtered.filter(
//       (notification) => notification.type === selectedType
//     );
//   }

//   // Filter by date range
//   if (fromDate && toDate) {
//     filtered = filtered.filter((notification) => {
//       const notificationDate = dayjs(notification.created_at);
//       return (
//         notificationDate.isAfter(dayjs(fromDate).subtract(1, 'day')) &&
//         notificationDate.isBefore(dayjs(toDate).add(1, 'day'))
//       );
//     });
//   }

//   return filtered;
// };

// // Window resize handler
// export const useWindowResize = (headerRef) => {
//   const [screenHeight, setScreenHeight] = useState(window.innerHeight);
//   const [headerHeight, setHeaderHeight] = useState(200);

//   useEffect(() => {
//     const handleResize = () => {
//       setScreenHeight(window.innerHeight);
//       if (headerRef.current) {
//         setHeaderHeight(headerRef.current.offsetHeight);
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize();

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, [headerRef]);

//   return { screenHeight, headerHeight };
// };

// // Custom hook for notification filtering
// export const useNotificationFilters = (notifications) => {
//   const [searchName, setSearchName] = useState('');
//   const [selectedStatus, setSelectedStatus] = useState('');
//   const [selectedSeverity, setSelectedSeverity] = useState('');
//   const [selectedType, setSelectedType] = useState('');
//   const [fromDate, setFromDate] = useState(null);
//   const [toDate, setToDate] = useState(null);

//   const filteredNotifications = useMemo(() => {
//     return filterNotifications({
//       notifications,
//       searchName,
//       selectedStatus,
//       selectedSeverity,
//       selectedType,
//       fromDate,
//       toDate,
//     });
//   }, [
//     notifications,
//     searchName,
//     selectedStatus,
//     selectedSeverity,
//     selectedType,
//     fromDate,
//     toDate,
//   ]);

//   return {
//     searchName,
//     setSearchName,
//     selectedStatus,
//     setSelectedStatus,
//     selectedSeverity,
//     setSelectedSeverity,
//     selectedType,
//     setSelectedType,
//     fromDate,
//     setFromDate,
//     toDate,
//     setToDate,
//     filteredNotifications,
//   };
// };

import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

// Window resize hook
export const useWindowResize = (headerRef) => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [headerHeight, setHeaderHeight] = useState(200);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };
    
    window.addEventListener('resize', handleResize);
    handleResize();
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [headerRef]);

  return { screenHeight, headerHeight };
};

// Notification filters hook (simplified since we're using API)
export const useNotificationFilters = (initialNotifications = []) => {
  const [searchName, setSearchName] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedSeverity, setSelectedSeverity] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  return {
    searchName,
    setSearchName,
    selectedStatus,
    setSelectedStatus,
    selectedSeverity,
    setSelectedSeverity,
    selectedType,
    setSelectedType,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
  };
};

// Export to CSV function
export const handleExportToCSV = (notifications) => {
  if (!notifications || notifications.length === 0) {
    alert('No data to export');
    return;
  }

  const exportData = notifications.map((notification) => ({
    'Plant Name': notification.plantName,
    'Plant ID': notification.plantId,
    'Type': notification.type,
    'Message': notification.message,
    'Status': notification.status,
    'Severity': notification.severity,
    'Created Date': dayjs(notification.created_at).format('DD-MM-YYYY HH:mm:ss'),
    'Last Data Time': notification.lastDataTime 
      ? dayjs(notification.lastDataTime).format('DD-MM-YYYY HH:mm:ss') 
      : 'N/A',
    'Current Time': notification.currentTime 
      ? dayjs(notification.currentTime).format('DD-MM-YYYY HH:mm:ss') 
      : 'N/A',
    'Resolved': notification.resolved ? 'Yes' : 'No',
    'Resolution Time': notification.resolutionTime
      ? dayjs(notification.resolutionTime).format('DD-MM-YYYY HH:mm:ss')
      : 'N/A',
    'Resolution Details': notification.resolutionDetails || 'N/A',
    'Email Sent': notification.emailSent ? 'Yes' : 'No',
    'Email Sent Time': notification.emailSentTime
      ? dayjs(notification.emailSentTime).format('DD-MM-YYYY HH:mm:ss')
      : 'N/A',
    'Escalation Level': notification.escalationLevel || 'N/A',
    'Escalation Time': notification.escalationTime
      ? dayjs(notification.escalationTime).format('DD-MM-YYYY HH:mm:ss')
      : 'N/A',
    'Last Escalated': notification.lastEscalated
      ? dayjs(notification.lastEscalated).format('DD-MM-YYYY HH:mm:ss')
      : 'N/A',
    'Processed': notification.processed ? 'Yes' : 'No',
  }));

  // Convert to CSV
  const headers = Object.keys(exportData[0]);
  const csvContent = [
    headers.join(','),
    ...exportData.map(row => 
      headers.map(header => {
        const value = row[header];
        // Escape commas and quotes in values
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',')
    )
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `notifications_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Format duration helper
export const formatDuration = (startTime, endTime) => {
  if (!startTime || !endTime) return 'N/A';
  
  const start = dayjs(startTime);
  const end = dayjs(endTime);
  const duration = end.diff(start, 'minutes');

  if (duration < 0) return 'Invalid duration';
  
  if (duration < 60) {
    return `${duration} minutes`;
  } else if (duration < 1440) {
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    return `${hours}h ${minutes}m`;
  } else {
    const days = Math.floor(duration / 1440);
    const hours = Math.floor((duration % 1440) / 60);
    const minutes = duration % 60;
    if (minutes > 0) {
      return `${days}d ${hours}h ${minutes}m`;
    }
    return `${days}d ${hours}h`;
  }
};

// Get relative time (e.g., "2 hours ago")
export const getRelativeTime = (date) => {
  if (!date) return 'N/A';
  
  const now = dayjs();
  const target = dayjs(date);
  const diffMinutes = now.diff(target, 'minutes');
  
  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
  
  const diffHours = now.diff(target, 'hours');
  if (diffHours < 24) return `${diffHours} hours ago`;
  
  const diffDays = now.diff(target, 'days');
  if (diffDays < 7) return `${diffDays} days ago`;
  
  return target.format('DD-MM-YYYY');
};

// Validate date range
export const validateDateRange = (fromDate, toDate) => {
  if (!fromDate || !toDate) return { isValid: true, message: '' };
  
  const from = dayjs(fromDate);
  const to = dayjs(toDate);
  
  if (from.isAfter(to)) {
    return { 
      isValid: false, 
      message: 'From date cannot be after To date' 
    };
  }
  
  const diffDays = to.diff(from, 'days');
  if (diffDays > 365) {
    return { 
      isValid: false, 
      message: 'Date range cannot exceed 365 days' 
    };
  }
  
  return { isValid: true, message: '' };
};

// Debounce hook for search
export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

// Format notification type for display
export const formatNotificationType = (type) => {
  if (!type) return 'Unknown';
  
  return type
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, l => l.toUpperCase());
};

// Get priority level based on severity and type
export const getPriorityLevel = (severity, type) => {
  const severityScore = {
    'critical': 4,
    'high': 3,
    'medium': 2,
    'low': 1
  };
  
  const typeScore = {
    'COMMUNICATION_ERROR': 3,
    'GENERATION_DATA_ERROR': 4,
    'GENERATION_LOSS': 4,
    'SYSTEM_ALERT': 2,
    
  };
  
  const severityValue = severityScore[severity?.toLowerCase()] || 1;
  const typeValue = typeScore[type] || 1;
  
  const totalScore = severityValue + typeValue;
  
  if (totalScore >= 7) return 'Critical';
  if (totalScore >= 5) return 'High';
  if (totalScore >= 3) return 'Medium';
  return 'Low';
};

// Check if notification needs attention (unread and high priority)
export const needsAttention = (notification) => {
  const isUnread = notification.status === 'unread' || notification.status === 'active';
  const isHighPriority = notification.severity === 'critical' || notification.severity === 'high';
  const isRecent = dayjs().diff(dayjs(notification.created_at), 'hours') < 24;
  
  return isUnread && isHighPriority && isRecent;
};

// Group notifications by date
export const groupNotificationsByDate = (notifications) => {
  return notifications.reduce((groups, notification) => {
    const date = dayjs(notification.created_at).format('YYYY-MM-DD');
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(notification);
    return groups;
  }, {});
};

// Calculate notification trends
export const calculateTrends = (notifications, days = 7) => {
  const now = dayjs();
  const periods = [];
  
  for (let i = days - 1; i >= 0; i--) {
    const date = now.subtract(i, 'days');
    const startOfDay = date.startOf('day');
    const endOfDay = date.endOf('day');
    
    const dayNotifications = notifications.filter(n => {
      const nDate = dayjs(n.created_at);
      return nDate.isAfter(startOfDay) && nDate.isBefore(endOfDay);
    });
    
    periods.push({
      date: date.format('YYYY-MM-DD'),
      count: dayNotifications.length,
      critical: dayNotifications.filter(n => n.severity === 'critical').length,
      resolved: dayNotifications.filter(n => n.status === 'resolved').length
    });
  }
  
  return periods;
};